import { render, staticRenderFns } from "./bind_kin.vue?vue&type=template&id=1fc6cb50&scoped=true"
import script from "./bind_kin.vue?vue&type=script&lang=js"
export * from "./bind_kin.vue?vue&type=script&lang=js"
import style0 from "./bind_kin.vue?vue&type=style&index=0&id=1fc6cb50&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6cb50",
  null
  
)

export default component.exports